import {FC, useMemo, useState} from 'react'
import {Dropdown} from 'react-bootstrap'
import find from 'lodash/find'
import {globalFilter, premiumFeaturesType} from 'app/constant'
import {useSubscription} from 'app/features/subscription/SubscriptionContext'
import reject from 'lodash/reject'

const OrderTypes = [
  {
    id: 'E_COMMERCE',
    name: 'E-commerce',
  },
  {
    id: 'WINE_CLUB',
    name: 'Wine club',
  },
  {
    id: 'ADMIN_PORTAL',
    name: 'Manual Order',
  },
  {
    id: 'POS',
    name: 'POS',
  },
]

type Props = {
  filter: any
  setFilter: (value: any) => any
}

const OrderTypeFilter: FC<Props> = ({filter, setFilter}) => {
  const {isPOSFeatureEnabled} = useSubscription()

  const orderTypeName = useMemo(() => {
    if (filter.orderType) {
      const result = find(OrderTypes, {id: filter.orderType})
      if (result) {
        return result.name
      }
    }
    return 'Order Type'
  }, [filter.orderType])

  const getOrderTypes = useMemo(() => {
    if (isPOSFeatureEnabled) {
      return OrderTypes
    }
    return reject(OrderTypes, {id: premiumFeaturesType.POS})
  }, [isPOSFeatureEnabled])

  const handleChange = (orderType: any) => {
    if (orderType === '') {
      orderType = null
    }
    setFilter({
      ...filter,
      orderType,
      offset: 0,
      wineClubId: orderType === 'WINE_CLUB' ? filter.wineClubId : null,
    })
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant='transparent' className={`${globalFilter.css} px-7 mt-1`}>
        {orderTypeName}
      </Dropdown.Toggle>
      <Dropdown.Menu className='form-control border-dark border ms-1 mt-1'>
        <Dropdown.Item eventKey='' as='button' onSelect={handleChange}>
          All
        </Dropdown.Item>
        {getOrderTypes.map((type) => (
          <Dropdown.Item key={type.id} eventKey={type.id} as='button' onSelect={handleChange}>
            {type.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default OrderTypeFilter
